// extracted by mini-css-extract-plugin
export default {"ticketsPreviews":"TicketsPreviews_ticketsPreviews__nagDO"};